<template>
  <f7-page>
    <!-- Card exterior con sombra y padding (igual que Fincas) -->
    <div class="outer-card">
      <!-- Submenú -->
      <div class="sub-menu-wrapper">
        <SubMenu
          :items="MenuOptions.contexts.samples.itemsByArea.agronomy"
        />
      </div>

      <!-- Título -->
      <div class="summary-sidebar-header">
        <span class="summary-title-text">
          {{ $t(isEditingFarm ? 'editParcel' : 'registerParcel') }}
        </span>
      </div>

      <!-- Card interior: formulario gris + mapa -->
      <div class="card-wrapper">
        <div class="info-card">
          <RegisterParcelForm />
        </div>

        <div class="map-card">
          <GisEditor
            :name-map="'addParcel'"
            :zoom="20"
            :tree-locations="isCreatingParcel ? false : true"
            :disabled-edit-sector="isEditingFarm ? false : true"
            :create-sector="isEditingFarm ? false : true"
          />
        </div>
      </div>

      <!-- Botón -->
      <f7-row class="margin-top-half">
        <f7-col style="display: flex; justify-content: flex-end">
          <DxButton
            :width="100"
            class="standardBtn marginTop15"
            type="normal"
            styling-mode="outlined"
            :text="$t('save')"
            @click="save"
          />
        </f7-col>
      </f7-row>
    </div>
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import GisEditor from '@/components/Gis/Editor/index.vue';
import DxButton from 'devextreme-vue/button';
import RegisterParcelForm from '@/components/Agronomy/AdvancedServices/RegisterParcelForm/index.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';

/* añadidos para replicar cabecera de Fincas */
import SubMenu from '@/components/SubMenu/index.vue';
import MenuOptions from '@/json/menuOptions.json';

export default {
  components: {
    GisEditor,
    RegisterParcelForm,
    DxButton,
    SubMenu,
  },
  data() {
    return {
      MenuOptions,
    };
  },
  computed: {
    ...mapState('gisEditor', [
      'parcelCentroide',
      'parcelIndex',
      'centroide',
    ]),
    ...mapState('registerFarm', [
      'farm',
      'farmId',
      'parcel',
      'isEditingFarm',
      'isCreatingParcel',
      'isRecreatingParcel',
      'parcelOverlaps',
    ]),
  },
  beforeMount() {
    if (this.isEditingFarm) {
      this.setCurrentRoute([
        {
          name: this.$t('Agronomy'),
          disabled: false,
          page: 'AgronomySamplesPage',
          active: false,
        },
        {
          name: this.$t('advancedServices'),
          disabled: false,
          page: 'AdvancedServicesPage',
          active: false,
        },
        {
          name: this.$t('editParcel'),
          disabled: true,
          page: 'AdvancedServicesParcelRegistrationPage',
          active: true,
        },
      ]);
    } else if (this.centroide && !this.isRecreatingParcel) {
      this.setCurrentRoute([
        {
          name: this.$t('Agronomy'),
          disabled: false,
          page: 'AgronomySamplesPage',
          active: false,
        },
        {
          name: this.$t('advancedServices'),
          disabled: false,
          page: 'AdvancedServicesPage',
          active: false,
        },
        {
          name: this.$t('registerFarm'),
          disabled: false,
          page: 'AdvancedServicesManagementPage',
          active: false,
        },
        {
          name: this.$t('registerParcel'),
          disabled: true,
          page: 'AdvancedServicesParcelRegistrationPage',
          active: true,
        },
      ]);
    } else {
      this.setCurrentRoute([
        {
          name: this.$t('Agronomy'),
          disabled: false,
          page: 'AgronomySamplesPage',
          active: false,
        },
        {
          name: this.$t('advancedServices'),
          disabled: false,
          page: 'AdvancedServicesPage',
          active: false,
        },
        {
          name: this.$t('registerParcel'),
          disabled: true,
          page: 'AdvancedServicesParcelRegistrationPage',
          active: true,
        },
      ]);
    }
  },
  methods: {
    async save() {
      try {
        if (!this.farm || !this.parcel) {
          this.$notifyDX(
            { message: this.$t('fillRequiredFields'), width: 350 },
            'error',
            NOTIFY_TIME_LONG
          );
          return;
        }

        if (this.parcelOverlaps) {
          this.$notifyDX(
            { message: this.$t('parcelOverlaps'), width: 450 },
            'error',
            NOTIFY_TIME_LONG
          );
          return;
        }

        if (!this.parcelCentroide) {
          this.$notifyDX(
            { message: this.$t('Gis.mustDrawGeometry'), width: 350 },
            'error',
            NOTIFY_TIME_LONG
          );
          return;
        }

        this.$f7.preloader.show();

        if (
          !this.isEditingFarm &&
          !this.isCreatingParcel &&
          !this.isRecreatingParcel
        ) {
          const farmRes = await this.saveFarmGeoFeature({
            includesParent: false,
          });
          await this.saveFarmGeoFeature({
            includesParent: true,
            parentId: farmRes.id,
          });
        } else if (this.isEditingFarm) {
          await this.saveFarmGeoFeature({
            includesParent: true,
            parentId: null,
          });
        } else if (!this.isEditingFarm && this.isCreatingParcel) {
          await this.saveFarmGeoFeature({
            includesParent: true,
            parentId: this.farmId,
          });
        } else {
          await this.saveFarmGeoFeature();
        }

        if (!this.isEditingFarm) {
          this.$notifyDX(
            { message: this.$t('registerFarmSuccess'), width: 350 },
            'success',
            3000
          );
        } else {
          this.$notifyDX(
            { message: this.$t('editParcelSuccess'), width: 350 },
            'success',
            3000
          );
        }

        if (!this.isEditingFarm) {
          this.setParcelIndex(this.parcelIndex + 1);
          this.resetParcelGeoFeatureStations();
          this.$f7router.navigate(
            { name: 'AdvancedServicesStationRegistrationPage' },
            { animate: true, transition: 'f7-fade' }
          );
        } else {
          this.$f7router.navigate(
            { name: 'AdvancedServicesPage' },
            { animate: true, transition: 'f7-fade' }
          );
        }
      } catch (e) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(e.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('registerFarm', [
      'postHidrosophStationsForParcels',
      'setStations',
      'saveFarmGeoFeature',
    ]),
    ...mapActions('gisEditor', [
      'setParcelIndex',
      'resetParcelGeoFeatureStations',
    ]),
  },
};
</script>

<style scoped>
/* ======= MISMO DISEÑO QUE FINCAS ======= */

/* Card exterior */
.outer-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(87, 84, 95, 0.3);
  padding: 24px;
  display: flex;
  flex-direction: column;
  padding-left: 15px;
}

/* Submenú y título */
.sub-menu-wrapper {
  width: 100%;
}
.summary-sidebar-header {
  font-size: 20px;
  font-weight: bold;
  color: var(--Primary-Blue-60, #00346a);
  margin: 0;
  padding-left: 24px;
}
.summary-title-text {
  display: inline-block;
}

/* Card interior (form + map) */
.card-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  padding: 24px;
  padding-top: 18px !important;
  height: 60vh;
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
}

/* Panel gris del formulario */
.info-card {
  width: 400px;
  background: var(--Neutral-10, #f7f7f8);
  border-radius: 10px;
  padding: 16px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* Contenedor del mapa */
.map-card {
  flex-grow: 1;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

/* Forzar el alto del mapa interno de GisEditor/Leaflet */
.map-card :deep(> div),
.map-card :deep(> div > div) {
  height: 100% !important;
  width: 100% !important;
}

/* Botón */
.marginTop15 {
  margin-top: -20px;
}

/* Evita sombra duplicada dentro */
.outer-card .card-wrapper {
  box-shadow: none;
}
</style>
